import { loadAcalogAPI } from "./acalogAPI.js";
import { processCourseMap } from "./modules/courseMap.js";
import { processOverview, processAosOverview } from "./modules/overview";
import { processAosCourses } from "./modules/aosCourses";
import { processProgramLearningOutcomes } from "./modules/learningOutcomes";
import { processProgramReqs } from "./modules/programReqs";
import { processProgramNotes } from "./modules/programNote";
import { processProgramAccreditation } from "./modules/programAccreditation";
// import { processCareerPathways } from "./modules/careerPathways";
import { initCourseMapToggle } from "./toggleCourseMap.js";

initCourseMapToggle();

function doACALogAPI() {
  if (typeof window.$ === "undefined" && typeof window.jQuery !== "undefined") {
    window.$ = window.jQuery;
  }

  // Program Data
  $(function () {
    var acalog = $(".acalog.js-hideAcalog");

    if (!acalog.length) {
      // console.error("No .acalog div found!");
      return;
    }

    acalog.hide();
    acalog.acalogWidgetize({ gateway: "https://catalog.sunywcc.edu" });

    var checkAcalogLoaded = setInterval(function () {
      let acalog = $(".acalog.js-hideAcalog");

      if (!acalog.length) {
        return;
      }

      let sections = [
        { selector: ".js-programCourseMap", handler: processCourseMap, searchFor: 'h2.acalog-program-core-name:contains("Program Map")' },
        { selector: ".js-overview", handler: processOverview, searchFor: 'h2.acalog-program-core-name:contains("Program Description")' },
        { selector: ".js-programLearningOutcomes", handler: processProgramLearningOutcomes, searchFor: 'h3.acalog-program-core-name:contains("Program Learning Outcomes")' },
        { selector: ".js-programReqs", handler: processProgramReqs, searchFor: 'h2.acalog-program-core-name:contains("Program Requirements")' },
        { selector: ".js-programNotes", handler: processProgramNotes, searchFor: 'h2:contains("Program Note")' },
        { selector: ".js-programAccreditation", handler: processProgramAccreditation, searchFor: 'h2:contains("Accreditation")' },
        //TODO Doesnt exist { selector: ".js-careerPathways", handler: processCareerPathways, searchFor: 'h2.acalog-program-core-name:contains("Career Pathways")' },
      ];

      let foundSections = 0;

      sections.forEach(({ selector, handler, searchFor }) => {
        let module = $(selector);
        if (!module.length) return;

        // console.log('acalog', acalog[0].innerHTML);

        let sectionTitle = acalog.find(searchFor).first();
        if (!sectionTitle.length && foundSections !== 0) {
          module.hide();
          return;
        }

        let mapContainer = sectionTitle.closest(".acalog-program-core");

        // console.log('mapContainer', mapContainer[0].innerHTML);
        if (!mapContainer.length) {
          return;
        }

        handler(module, mapContainer);
        foundSections++;
      });

      if (foundSections > 0) {
        clearInterval(checkAcalogLoaded);
      }
    }, 500);
  });

  // AOS Data
  $(function () {
    let programName = window.aosProgramName;

    if (!programName) return;

    var acalog = $(".acalog.js-hideAcalog");

    if (!acalog.length) {
      // console.error("No .acalog div found!");
      return;
    }

    acalog.hide();
    acalog.acalogWidgetize({
      gateway: "https://catalog.sunywcc.edu",
      data: 'programs',
      catalogFilter: 'x',
      programName
    });

    var checkAcalogLoaded = setInterval(function () {
      let acalog = $(".acalog.js-hideAcalog");

      if (!acalog.length) {
        return;
      }

      let sections = [
        { selector: ".js-aosOverview", handler: processAosOverview, searchFor: 'div.acalog-program-description', searchFor2: 'div.acalog-program-core-description' },
        { selector: ".js-aosProgramCourse", handler: processAosCourses, searchFor: 'div.acalog-program-cores', sectionFound: '' },
        //TODO Doesnt exist { selector: ".js-careerPathways", handler: processCareerPathways, searchFor: 'h2.acalog-program-core-name:contains("Career Pathways")' },
      ];

      let foundSections = 0;

      sections.forEach(({ selector, handler, searchFor, searchFor2 }) => {
        let module = $(selector);
        if (!module.length) return;

        let sectionFound = acalog.find(searchFor).first();
        if (!sectionFound.length || sectionFound.is(':empty')) {
          sectionFound = acalog.find(searchFor2).first();

          if (!sectionFound.length)
            return;
        }

        let mapContainer = sectionFound;

        if (!mapContainer.length) {
          return;
        }

        handler(module, mapContainer);
        foundSections++;
      });

      if (foundSections > 0) {
        clearInterval(checkAcalogLoaded);
      }
    }, 500);
  });
}

loadAcalogAPI(doACALogAPI);